const r = {
  true: { borderRadius: "full" }
};
export {
  r as rounded
};
